import { AggregationStrategy } from './AggregationStrategy';
import { SideAggregationStrategy } from './SideAggregationStrategy';
import { EnumMapAggregationStrategy } from './EnumMapAggregationStrategy';
import { DefaultAggregationStrategy } from './DefaultAggregationStrategy';
import * as EnumMaps from 'widgets/blotter/columns/EnumMaps';
import { AggregationField } from '../fields/aggregationFieldPortfolio';

export const getAggregationStrategy: (
    aggregationField: AggregationField,
    combineSellsAndShorts: boolean
) => AggregationStrategy = (aggregationField, combineSellsAndShorts) => {
    switch (aggregationField) {
        case 'side':
            return new SideAggregationStrategy(combineSellsAndShorts);
        case 'svol':
            return new EnumMapAggregationStrategy(
                EnumMaps.svol,
                'svol',
                combineSellsAndShorts
            );
        case 'liq':
            return new EnumMapAggregationStrategy(
                EnumMaps.liq,
                'liq',
                combineSellsAndShorts
            );
        case 'mcap':
            return new EnumMapAggregationStrategy(
                EnumMaps.mcap,
                'mcap',
                combineSellsAndShorts
            );
        case 'dcat':
            return new EnumMapAggregationStrategy(
                EnumMaps.dcat,
                'dcat',
                combineSellsAndShorts
            );
        default:
            return new DefaultAggregationStrategy(
                aggregationField,
                combineSellsAndShorts
            );
    }
};
